<ion-app [class.dark-theme]="dark">
  <ion-split-pane contentId="main-content">
    <ion-menu contentId="main-content" style="width: 300px">
      <ion-header style="border-bottom: 2px solid var(--ion-color-primary)">
        <ion-toolbar color="primary">
          <ion-title
            style="color: white; padding-left: 0; padding-right: 0; margin-top: 2.5px; margin-bottom: 2.5px"
            (click)="navigateToRoot('menu')"
          >
            <img style="height: 50px" src="../assets/img/logos/logo_i4life_es_blanco.svg" />
          </ion-title>
        </ion-toolbar>
      </ion-header>

      <ion-content style="--background: none">
        <ion-list lines="none">
          <ion-menu-toggle autoHide="false">
            <div class="language">
              @if (language == "es") {
                <img src="assets/img/bandera_espania.svg" alt="" />
              } @else if (language == "pt") {
                <img src="assets/img/bandera_portugal.svg" alt="" />
              }
              <span>{{ "languages.title" | translate }}:</span>
              <ion-select [(ngModel)]="language" (ionChange)="changeLanguage()" interface="popover">
                <ion-select-option value="es">{{ "languages.es" | translate }}</ion-select-option>
                <ion-select-option value="pt">{{ "languages.pt" | translate }}</ion-select-option>
              </ion-select>
            </div>
            <ion-item button (click)="navigateToRoot('menu')" style="margin-bottom: 3%">
              <ion-icon slot="start" src="../assets/img/icons/apps-outline.svg"></ion-icon>
              <ion-label> {{ "menu" | translate }} </ion-label>
            </ion-item>
            <ion-item button (click)="navigateToRoot('atencion-usuarios')" style="margin-bottom: 2%">
              <ion-icon slot="start" src="../assets/img/icons/id-card-outline.svg"></ion-icon>
              <ion-label> {{ "user_service.title" | translate }} </ion-label>
            </ion-item>

            <ion-item button (click)="navigateToRoot('gestion-usuarios')" style="margin-bottom: 2%">
              <ion-icon slot="start" src="../assets/img/icons/person-outline.svg"></ion-icon>
              <ion-label> {{ "users.title" | translate }} </ion-label>
            </ion-item>

            <ion-item button (click)="navigateToRoot('gestion-empleados')" style="margin-bottom: 2%">
              <ion-icon slot="start" src="../assets/img/icons/medkit-outline.svg"></ion-icon>
              <ion-label>{{ "caregivers.title" | translate }}</ion-label>
            </ion-item>

            <ion-item button (click)="navigateToRoot('gestion-familiares')" style="margin-bottom: 2%">
              <ion-icon slot="start" src="../assets/img/icons/people-outline.svg"></ion-icon>
              <ion-label> {{ "relatives.title" | translate }} </ion-label>
            </ion-item>

            @if (!hideAnnouncements) {
              <ion-item button (click)="navigateToRoot('gestion-anunciantes')" style="margin-bottom: 2%">
                <ion-icon slot="start" src="../assets/img/icons/megaphone-outline.svg"></ion-icon>
                <ion-label> {{ "advertisers.title" | translate }} </ion-label>
              </ion-item>
            }

            <ion-item button (click)="navigateToRoot('gestion-viviendas')" style="margin-bottom: 2%">
              <ion-icon slot="start" src="../assets/img/icons/home-outline.svg"></ion-icon>
              <ion-label> {{ "houses.title" | translate }} </ion-label>
            </ion-item>

            <ion-item button (click)="navigateToRoot('gestion-dispositivos')" style="margin-bottom: 2%">
              <ion-icon slot="start" src="../assets/img/icons/watch-outline.svg"></ion-icon>
              <ion-label> {{ "devices.title" | translate }} </ion-label>
            </ion-item>

            @if (isBraganca) {
              <ion-item button detail="false" href="https://www.robot.i4life.es" target="_blank" style="margin-bottom: 2%">
                <ion-icon slot="start" name="hardware-chip-outline"></ion-icon>
                <ion-label> {{ "robot_app" | translate }} </ion-label>
                <ion-icon slot="end" name="open-outline"></ion-icon>
              </ion-item>
            }
          </ion-menu-toggle>
        </ion-list>
        <ion-list lines="none">
          <ion-menu-toggle autoHide="false">
            <ion-item button detail="false" (click)="logout()" color="dangerSoft">
              <ion-icon slot="start" src="../assets/img/icons/log-out-outline.svg" style="color: white"></ion-icon>
              <ion-label>{{ "logout" | translate }}</ion-label>
            </ion-item>
          </ion-menu-toggle>
        </ion-list>
        <div class="logos-zamora" style="display: flex">
          <img src="assets/img/logos/Diputacion Zamora Logo 2020 2H color.png" alt="Diputación de Zamora" />

          <img style="width: 25%" src="assets/img/logos/logo territory silver economy.jpg" alt="Silver economy" />
        </div>
        <div style="text-align: center">
          <img
            style="width: 90%"
            src="assets/img/logos/IMAGEN-Logotipo_de_la_Secretaría_General_para_el_Reto_Demográfico.png"
            alt=""
          />
        </div>
        <div style="margin: 0 18px; font-size: 13px; display: flex; flex-direction: column; gap: 3px">
          <a href="https://i4life.es/silverdigi-politica_privacidad/" target="_blank"
            >{{ "legal_documents.privacy_policy" | translate }}
          </a>
          <a href="https://i4life.es/silverdigi-contrato_uso/" target="_blank">
            {{ "legal_documents.use_licence" | translate }}
          </a>
          <a href="https://i4life.es/silverdigi-aviso_legal/" target="_blank">
            {{ "legal_documents.legal_notice" | translate }}</a
          >
        </div>

        <!-- <div style="position: relative; height: 18%; width: 35%; margin: auto">
          <img
            style="height: 100%"
            src="{{ serverroute }}/uploads/images/councils/{{ idCouncil }}.png"
            alt=""
          />
        </div> -->
      </ion-content>
    </ion-menu>

    <ion-router-outlet id="main-content"></ion-router-outlet>
  </ion-split-pane>
</ion-app>
